export default __webpack_public_path__ + "static/media/044-turn-right.c21b44f3.png";